// Count sheet helpers (docs/STOCK-SPEC.md §7.3) — kept out of the view so they
// can be tested without a browser.

// A count far from Square's number is probably a typo: beyond ±20 units, or
// beyond ±50% of a positive count. Those get a second look before sending.
export function bigVariance(squareSays, counted) {
  const before = Number(squareSays) || 0;
  const diff = Math.abs(counted - before);
  if (diff > 20) return true;
  return before > 0 && diff / before > 0.5;
}

// Only the boxes someone typed in are sent; a blank box means "not counted",
// never zero.
export function countedLines(items, values) {
  return items
    .filter((i) => values[i.stock_item_id] !== undefined && values[i.stock_item_id] !== '')
    .map((i) => ({ ...i, counted: Number(values[i.stock_item_id]) }));
}

// The sheet is saved on the iPad as it is typed, so the 60-second idle sign-out
// or a reload never loses a half-done count. One draft per store.
export const draftKey = (locationKey) => `monarch.stockCount.${locationKey}`;

export function newToken() {
  const rnd = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `count-${rnd}`.slice(0, 64);
}

export function readDraft(storage, locationKey) {
  try {
    const d = JSON.parse(storage.getItem(draftKey(locationKey)) || 'null');
    if (d && typeof d.token === 'string' && d.values && typeof d.values === 'object') return d;
  } catch { /* unreadable draft: start fresh */ }
  return null;
}

export function writeDraft(storage, locationKey, draft) {
  try { storage.setItem(draftKey(locationKey), JSON.stringify(draft)); } catch { /* storage full or blocked */ }
}

export function clearDraft(storage, locationKey) {
  try { storage.removeItem(draftKey(locationKey)); } catch { /* blocked */ }
}
